// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"92":"2e9f5a0d","570":"2ef81caf","657":"2e9f5a0d","823":"2e9f5a0d"}[chunkId] + ".chunk.css";
};